export const themenCards = [
  {
    title: "rudi.Guide",
    to: "https://guide.ru-digital.de",
    description:
      "Mehr Zeit für das Wesentliche - mit digitalen Arbeitsplänen für den Religionsunterricht.",
  },
  {
    title: "rudi.Themen",
    to: "https://themen.ru-digital.de",
    description:
      "Relevantes erschließen. Bildung gestalten. Komplexes greifbar machen.",
  },
  {
    title: "rudi.Methoden",
    to: "https://explore.ru-digital.de/methoden/",
    description:
      "Entdecke Unterrichtsmethoden - praxisnah, fundiert und für alle Schulstufen geeignet!",
  },
];
